// extracted by mini-css-extract-plugin
export var blue = "_3d-g";
export var brand = "_3d-c";
export var darkGrey = "_3d-f";
export var disabled = "_3d-6";
export var disabledSubtle = "_3d-7";
export var error = "_3d-8";
export var green = "_3d-h";
export var grey = "_3d-e";
export var icon = "_3d-0";
export var inherit = "_3d-b";
export var lightGrey = "_3d-d";
export var orange = "_3d-j";
export var pink = "_3d-l";
export var primary = "_3d-1";
export var purple = "_3d-m";
export var quaternary = "_3d-4";
export var quinary = "_3d-5";
export var red = "_3d-k";
export var secondary = "_3d-2";
export var success = "_3d-a";
export var tertiary = "_3d-3";
export var warning = "_3d-9";
export var white = "_3d-n";
export var yellow = "_3d-i";